<template>
  <div class="card kpiChart" style="margin-bottom: 15px">
    <div class="card-header" style="padding-top: 0px">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="d-flex" style>
            <h4 class="card-title companyProfileTabulatorTitle">
              Calls & Distributions
            </h4>
            <div
              style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
              v-tooltip.top-end="toolTipInfo"
            >
              <img src="static/img/graphInfo.svg" class />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="padding-top: 0px">
      <chartjs-line
        :chartData="chartData"
        :chartOptions="chartOptions"
        :style="lineChartStyle"
      ></chartjs-line>
    </div>
  </div>
</template>
<script>
import { vals, formatCurrency, precisionNumberForamtter } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsLineCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
import ChartjsLine from "../../Chartjs/ChartjsLine";

const MONTH = "month";
const MONTH_FORMAT = "MMM YYYY";
const YEAR = "year";
const YEAR_FORMAT = "YYYY";
const QUARTER = "quarter";
const QUARTER_FORMAT = "[Q]Q YYYY";
const DAY = "day";
const DAY_FORMAT = "ll";

export default {
  name: "callsDistributionsChartCard",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsLineCard,
    ChartjsLine,
  },
  computed: {
    ...mapGetters("user", ["currency"]),
    chartUnit() {
      const self = this;
      // temp solution: do quarters
      // setup our time tick steps correctly based on data points
      switch (self.dateUnit) {
        case MONTH:
          // return month format
          return {
            tooltipFormat: MONTH_FORMAT,
            round: MONTH,
            unit: MONTH,
            displayFormats: {
              month: MONTH_FORMAT,
            },
          };
        case YEAR:
          // return year format
          return {
            tooltipFormat: YEAR_FORMAT,
            round: YEAR,
            unit: YEAR,
            displayFormats: {
              year: YEAR_FORMAT,
            },
          };
        case QUARTER:
          return {
            tooltipFormat: QUARTER_FORMAT,
            round: QUARTER,
            unit: QUARTER,
            displayFormats: {
              quarter: QUARTER_FORMAT,
            },
          };
        case DAY:
          return {
            tooltipFormat: DAY_FORMAT,
            round: DAY,
            unit: DAY,
            displayFormats: {
              day: DAY_FORMAT,
            },
          };
        default:
          return {};
      }
    },
    chartData() {
      const self = this;
      let callsDistributionsInfo = this.$store.getters[
        "charts/callsDistributonsChartData"
      ];
      self.dateUnit = DAY;
      let callsData = _.zipWith(
        callsDistributionsInfo.calls_t,
        callsDistributionsInfo.calls,
        function (x, y) {
          return { x, y };
        }
      );
      let distributionData = _.zipWith(
        callsDistributionsInfo.distributions_t,
        callsDistributionsInfo.distributions,
        function (x, y) {
          return { x, y };
        }
      );
      callsData.sort((a, b) => {
        return new Date(a.x) - new Date(b.x);
      });
      distributionData.sort((a, b) => {
        return new Date(a.x) - new Date(b.x);
      });
      let data = {
        datasets: [
          {
            label: "Calls",
            data: callsData,
            backgroundColor: "#6771DC",
            borderColor: "#6771DC",
            fill: false,
            //borderWidth: 1.8
          },
          {
            label: "Distributions",
            data: distributionData,
            backgroundColor: "#C767DC",
            borderColor: "#C767DC",
            fill: false,
            //borderWidth: 1.8
          },
        ],
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              let label = data.datasets[toolTipItem.datasetIndex].label || "";
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                ": $" +
                precisionNumberForamtter(
                  data.datasets[toolTipItem.datasetIndex].data[
                    toolTipItem.index
                  ].y || 0,
                  1,
                  true
                )
              );
            },
          },
        },
        legend: {
          position: "top",
          align: "end",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            //usePointStyle: true
          },
        },
        scales: {
          xAxes: [
            {
              type: "time",
              distribution: "series",
              bounds: "ticks",
              time: self.chartUnit,
              ticks: {
                source: "data",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return formatCurrency(value, self.currency.ref, 0);
                },
              },
            },
          ],
        },
      };
    },
    toolTipInfo() {
      return `This chart will show calls and distributions.`;
    },
    lineChartStyle() {
      return {
        position: "relative",
      };
    },
  },
  data() {
    return {
      category: {
        selected: "initial",
        title: "Time",
      },
      dataLength: 0,
      dateUnit: DAY,
    };
  },
  props: {
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows the ROI of your portfolio over time.`;
      },
    },
  },
  mounted() {
    const self = this;
  },
};
</script>
<style >
</style>